
import { Trans } from "@lingui/macro";
import React, { useCallback, useEffect, useState } from "react";
import BEMHelper from "react-bem-helper";
import {  Button } from 'reactstrap';

import './NumPad.css'

export const c = new BEMHelper({
  name: "NumPad",
});

type onChangeFn = (number: string) => void;
type onClickFn = (
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => void;

interface NumProps {
  children?: any;
  onClick?: onClickFn;
  style?: object;
}

const Num: React.FC<NumProps> = ({ children, onClick, style }) => {
  return (
    <Button
      {...c('numButton')}
      // @ts-ignore
      onClick={onClick}
      variant="elevated"
      style={{
        ...style,
      }}
    >
      {children}
    </Button>
  );
};

interface NumPadProps {
  pinCode: string;
  onChange: onChangeFn;
  onEnter?: onChangeFn;
  buttonStyle?: object;
  enter?: boolean;
}

const NumPad: React.FC<NumPadProps> = ({ pinCode, onChange, onEnter = () => {}, buttonStyle, enter = false }) => {
  const [enteredPincode, setEnteredPincode] = useState('');

  const handleChange = (evt: any) => {
    evt.preventDefault();
    setEnteredPincode(`${enteredPincode}${evt.currentTarget.textContent}`)
    if(!enter && enteredPincode === pinCode) {
      onEnter(pinCode);
    } 
  }

  const handleClear = () => {
    setEnteredPincode('');
  };

  const handleEnter = () => {
    onEnter(pinCode);
    setEnteredPincode('');
  }

  useEffect(() => {
    if(!enter) {
      onChange(enteredPincode);
    }
  }, [enteredPincode])

  const pinCodeLetters = Array.from(pinCode.toString());
  const enteredCodeLetters = Array.from(enteredPincode.toString())

  return (
    <div
      {...c('container')}
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <div style={{ display: 'flex'}}>
        {pinCodeLetters.map((l, index) => {
          return <Num style={buttonStyle}>
            {enteredCodeLetters[index] ? '*' : ''}
          </Num>
        })}
      </div>
      <div {...c('container__row')}>
        <Num style={buttonStyle} onClick={handleChange}>
          1
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          2
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          3
        </Num>
      </div>
      <div {...c('container__row')}>
        <Num style={buttonStyle} onClick={handleChange}>
          4
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          5
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          6
        </Num>
      </div>
      <div {...c('container__row')}>
        <Num style={buttonStyle} onClick={handleChange}>
          7
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          8
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          9
        </Num>
      </div>
      <div {...c('container__row')}>
        <Num style={buttonStyle} onClick={handleClear}>
          <Trans id="NumPad.clear" />
        </Num>
        <Num style={buttonStyle} onClick={handleChange}>
          0
        </Num>
        {enter ? <Num style={buttonStyle} onClick={handleEnter}>
          <Trans id="NumPad.enter" />
        </Num> : null}
      </div>
    </div>
  );
};

export { NumPad as default };
